import React from "react";

import { wrap } from "./RydTestbedWrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as ToneJS from "tone";
import { RydSpectrogram } from "../components/inspector/RydSpectrogram";
import { getAudioContext } from "../audio/AudioController";

export function RydSpectrogramTestbed() {

    const synthRef = React.useRef<any>(null);
    const outputRef = React.useRef<ToneJS.ToneAudioNode>(null);
    const [synth, setSynth] = React.useState<any>(null);
    const [audioContext, setAudioContext] = React.useState<AudioContext>();

    React.useEffect(() => {
        const ac = getAudioContext();
        setAudioContext(ac);
        console.log('Creating new AudioContext:', ac);
        ToneJS.setContext(ac);
        ToneJS.start();
        if (!synthRef.current) {
            const out = new ToneJS.Gain(1).toDestination();
            const s = new ToneJS.Synth({ oscillator: { type: "sine" } });
            s.connect(out);
            synthRef.current = s;
            outputRef.current = out;

            setSynth(s);
        }
        return () => {
            synthRef.current?.dispose?.();
            outputRef.current?.dispose?.();
        };
    }, []);


    console.log('outputRef.current?.output', outputRef.current?.output);

    // if (!synth || ! getAudioContext()) return <div><button onClick={() => {
    //     // if (!audioContextStore.audioContext) {
    //     const audioContext = getAudioContext();
    //     console.log('Creating new AudioContext:', audioContext);
    //     // audioContextStore.setAudioContext(audioContext);
    //     ToneJS.setContext(audioContext);
    //     ToneJS.start();
    // }
    // }
    // >Init audio</button></div>;

    if(!audioContext) return <div>Loading...</div>;

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>RydSpectrogram Testbed</h1>
        <button
            onClick={() => {
                synth.triggerAttack("C4");
                setTimeout(() => {
                    synth.triggerRelease();
                }, 200);
            }}
        >trigger</button>
        <RydSpectrogram source={outputRef.current?.output} audioContext={audioContext} />
    </>);
}